

jQuery(function ($) {
    $('.id-1 .benefitBanner').insertAfter('.id-1 .banners-row');
});
jQuery(document).ready(function ($) {
    $('.footer-banners').insertAfter('#products-3');
});



/*
if ($(window).width() < 999) {
    setTimeout(function () {
        $('<div></div>').load('/obleceni/', function (page) {

            function ocistiOdObrazku(levelIdent, base) {
                base.find(levelIdent + ' > li').each(function () {
                    var $li = $(this);
                    var div = $li.find(' > div');
                    if (div.length > 0) {
                        $li.html(div.html());
                    }
                    $li.find('b').remove();
                });
            }

            var menuLevel1 = $('.navigation-in .menu-level-1').clone();
            var menuSmenu = $('.navigation-in .smenu').clone();

            menuLevel1.find('.submenu-arrow').remove();

            [2, 3, 4, 5, 6].forEach(function (lvl) {
                ocistiOdObrazku('.menu-level-' + lvl, menuLevel1);
            });

            var nav = $(`
        <a class="mburg" href="#menu-pt">
          <button class="mburger mburger--collapse"><b></b><b></b><b></b></button>
        </a>
        <nav id="menu-pt">
          <ul id="menu-list-pt"></ul>
        </nav>
      `);

            nav.prependTo('#header');

            var finalMenu = $('<ul></ul>');
            finalMenu.append(menuLevel1.html());
            finalMenu.append(menuSmenu.html());

            $('#menu-list-pt').html(finalMenu.html());

            new Mmenu("#menu-pt", {
                extensions: ["pagedim-black"]
            });
        });
    }, 0);
}
*/